import { render, staticRenderFns } from "./NewGsCalendar.vue?vue&type=template&id=307c2d3c&scoped=true"
import script from "./NewGsCalendar.vue?vue&type=script&lang=js"
export * from "./NewGsCalendar.vue?vue&type=script&lang=js"
import style0 from "./NewGsCalendar.vue?vue&type=style&index=0&id=307c2d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307c2d3c",
  null
  
)

export default component.exports